import { c as _c } from "react/compiler-runtime";
import type { ClipboardEvent, RefObject } from 'react';
import { useCallback } from 'react';
import { createMarkdownLinkFromPastedUrl } from '../utils/markdown-formatters';
type UseMarkdownLinkPasteParams = {
  onChange: (value: string) => void;
  textareaRef: RefObject<HTMLTextAreaElement | null>;
};

/**
 * Returns an `onPaste` handler for a controlled <textarea> that wraps the current
 * selection in a markdown link when an http(s) URL is pasted over it. Mirrors the
 * behavior built into AutosizeTextarea so plain textareas (the inline diff draft
 * composer and the comment edit box) get the same affordance.
 */
export const useMarkdownLinkPaste = t0 => {
  const $ = _c(3);
  const {
    onChange,
    textareaRef
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== textareaRef) {
    t1 = event => {
      const pastedLink = createMarkdownLinkFromPastedUrl({
        value: event.currentTarget.value,
        selectionStart: event.currentTarget.selectionStart,
        selectionEnd: event.currentTarget.selectionEnd,
        pastedText: event.clipboardData.getData("text/plain") || event.clipboardData.getData("text")
      });
      if (!pastedLink) {
        return;
      }
      event.preventDefault();
      onChange(pastedLink.value);
      requestAnimationFrame(() => {
        const textarea = textareaRef.current;
        if (textarea && document.body.contains(textarea)) {
          textarea.focus();
          textarea.setSelectionRange(pastedLink.selectionStart, pastedLink.selectionStart);
        }
      });
    };
    $[0] = onChange;
    $[1] = textareaRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};